import { render, staticRenderFns } from "./BillingTable.component.vue?vue&type=template&id=038c01ba"
import script from "./BillingTable.component.vue?vue&type=script&lang=ts"
export * from "./BillingTable.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports